import React, { useState, useEffect, useRef } from "react";
import Config from "../../utils/config";
import Request from "../../utils/Request";
import CsvDown from "../../components/ExportFiles/CsvDown";
import Pagination from "../../components/common/Pagination";
import { useNavigate } from "react-router-dom";
import { TableWarpper, TabsDetailsWrapper, Text, ButtonSolid } from "../../components/styledConstants";
import { Heading } from "../../components/styledConstants";
import { Wrapper } from "./style";
import IconDate from "../../assets/images/IconDate";
import { getParams } from "../../utils/common";
import FilterBox from "../../components/common/FilterBox";
import { CSVLink, CSVDownload } from "react-csv";
import IconDownload from "../../assets/images/IconDownload";
import { dateConvertWithoutTime } from "../../utils/common";
import { FilterWrapper } from "../Merchants/style";

const paymentModeOptions = [
  { value: "P2P", label: "P2P" },
  { value: "BT", label: "BANK TRANSFER" },
  { value: "VA", label: "VIRTUAL ACCOUNT" },
  { value: "UPI_PAYMENT", label: "UPI PAYMENT" },
  { value: "UPI_COLLECT", label: "UPI COLLECT" },
  { value: "PREPAID_CARD", label: "PREPAID CARD" },
  { value: "BBPS", label: "BBPS" },
  { value: "MRE", label: "RECHARGE" },
  { value: "WALLET", label: "WALLET" },
  { value: "PAYMENT_GATEWAY", label: "PAYMENT GATEWAY" },
];

const statusOptions = [
    { value: "INITIATED", label: "INITIATED" },
    /*  {value: "DONE", label: "DONE" }, } */
    { value: "PENDING", label: "PENDING" },
    { value: "FAIL", label: "FAIL" },
    { value: "INPROCESS", label: "IN PROCESS" },
    { value: "DONE", label: "DONE" },
    /* { value: "REJECTED", label: "REJECTED" }, */
    { value: "REFUNDED", label: "REFUNDED" },
  ];
  const typeOptions = [
    { value: "DEBIT", label: "DEBIT" },
    { value: "CREDIT", label: "CREDIT" },
  ];
const filterForm = [
  
 
  {
    icon: <IconDate />,
    name: "fromDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "From Date",
    maxDate: new Date(),
    error: "",
  },
  {
    icon: <IconDate />,
    name: "toDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "To Date",
    maxDate: new Date(),
    error: "",
  },
 

  
];

export default function UpiReports() {
  const [controls, setControls] = useState([...filterForm]);
  const [filterFormData, setFilterFormData] = useState({ fromDate: "", toDate: "" });
  const [headers, setHeaders] = useState([]);
  const [reportName, setReportName] = useState("report.csv");
  const [reportList, setReportList] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloadPayload, setDownloadPayload] = useState({});
  const [loading, setLoading] = useState(false);
  const [columnKeys, setColumnKeys] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [totalElements, setTotalElements] = useState(10);
  const [isCsvDownloading, setIsCsvDownloading] = useState(false);


  let navigate = useNavigate();
  const csvLinkRef = useRef(null);

  const header =[
      { label: "Card Ending Number", key: "cardNumber" },

    
  ]

 const onFilterChange = (event, index) => {
  const _controls = [...controls];
  const newValue = event instanceof Date || (event && event.label) ? event : event ? event.target.value : event;

  if (_controls[index].name === "fromDate") {
    _controls[0].value = newValue;
    _controls[1].value = newValue; 
    _controls[1].minDate = new Date(newValue); 
    _controls[1].maxDate = new Date(newValue); 
    _controls[1].disabled = true; 
  } else {
    _controls[index].value = newValue;
  }

  setControls([..._controls]);
};



  const onFilterSubmit = (e) => {
       e.preventDefault();
       const params = getParams(controls);
       const _controls = [...controls];
       let flag = 0;
       if (params.fromDate) {
         setFilterFormData({ ...filterFormData, fromDate: params.fromDate, toDate: params.toDate });
         _controls[0].error = "";
       } else {
         _controls[0].error = "Date Required";
         flag = 1;
       }
   
       if (params.toDate) {
         setFilterFormData({ ...filterFormData, fromDate: params.fromDate, toDate: params.toDate });
         _controls[1].error = "";
       } else {
         _controls[1].error = "Date Required";
         flag = 1;
       }
   
   
     
       setControls([..._controls]);
       clearMessage();
       if (flag === 0) {
         getReportList(1);
       }
   
       setCurrentPage(1);
    };

  const getReportList = (page = 1) => {
    const successHandler = (res) => {
      console
      setLoading(false);
      if (res) {
        if (res?.data?.content) {
          setTotalPages(res?.data?.totalPages);
          setTotalElements(res?.data?.totalElements);
          let listKeys = [];
          if (res?.data?.content[0]) {
            listKeys = Object.keys(res?.data?.content[0]);
          }
          setColumnKeys(listKeys);
          setReportList(res?.data?.content);
          let _downloadData = [];

          _downloadData.push(listKeys);

          res?.data?.content.map((item) => {
            let _downloadItemData = [];
            listKeys.map((keyname) => {
              _downloadItemData.push(item[keyname]);
            });
            _downloadData.push(_downloadItemData);
          });
          setDownloadData(_downloadData);
        } else {
          setReportList([]);
          setColumnKeys([]);
          setDownloadData([]);
          setTotalPages(1);
        }
      }
    };
    const errorHandler = () => {};
    const api = new Request("", successHandler, errorHandler, false);
    setLoading(true);
    const params = getParams(controls);
    const today = new Date(); 
     const defaultDate = dateConvertWithoutTime(today);
    let payload = {
     
        fromDate: params?.fromDate ? dateConvertWithoutTime(params?.fromDate) : defaultDate,
        toDate: params?.toDate ? dateConvertWithoutTime(params?.toDate) : defaultDate, 
      pagination: {
        pageNo: page,
        pageSize: 10,
      },
    };
    setDownloadPayload(payload);
    setReportName(params?.transactionType?.value + ".csv");
    return api.post(`${Config.apis.admin.UPI_REPORTS}`, payload);
  };

  const downloadReportList = () => {
    if (isCsvDownloading) return; 

  setIsCsvDownloading(true);
    const successHandler = (res) => {
      if (res) {
        if (res.data?.content) {
          let listKeys = [];
          if (res?.data?.content[0]) {
            listKeys = Object.keys(res?.data?.content[0]);
          }

          let _downloadData = [];
          _downloadData.push(listKeys);
          res?.data?.content.map((item) => {
            let _downloadItemData = [];
            listKeys.map((keyname) => {
              _downloadItemData.push(item[keyname]);
            });
            _downloadData.push(_downloadItemData);
          });
          setDownloadData(_downloadData);
          setTimeout(() => {
            csvLinkRef.current.link.click();
          }, 0);
        }
      }
    };
    const errorHandler = () => {
 
    };
       setTimeout(() => {
setIsCsvDownloading(false);
}, 15000);
    const params = getParams(controls);
    const pagination = {
      pageNo: 1,
      pageSize: totalElements,
    }
    let payload = {...downloadPayload,pagination:pagination };
    const api = new Request("", successHandler, errorHandler, false);
 
    return api.post(`${Config.apis.admin.UPI_REPORTS}`, payload);
  };

  const clearMessage = () => {
    setTimeout(() => {
      const _controls = [...controls];
      _controls[0].error = "";
      _controls[1].error = "";
      setControls([..._controls]);
    }, 3000);
  };
  const setActivePage = (page) => {
    setCurrentPage(page);
    getReportList(page);
  };
  useEffect(()=>{
    getReportList();
  },[])
  const resetFilter = () => {
    filterForm.forEach((obj) => {
      obj.value = "";
    });
  };
  const refreshPage = () => {
    resetFilter();
    setCurrentPage(1);
    getReportList();
  };

  useEffect(()=>{
    return(()=>{
      resetFilter();
    })
  },[])
  return (
    <Wrapper>
      <div className="flex flex-center space-between mb10">
        <>
          <Heading size="xxl">UPI Report</Heading>
          <div className="flex gap10">
           

          {/* <CsvDown  url={`${Config.apis.admin.REPORT_BY_TRANSACTION}`} filename={reportName} className="flex"></CsvDown> */}
          
          <ButtonSolid
           as="span"
           className="flex flex-center"
           primary
           lg
           onClick={downloadReportList}
           disabled={isCsvDownloading}
           style={{ cursor: isCsvDownloading ? "not-allowed" : "pointer", opacity: isCsvDownloading ? 0.6 : 1 }}
             >
            <IconDownload className="mr8" />
            {isCsvDownloading ? "Please wait..." : "CSV"}
          </ButtonSolid>
          <CSVLink  className="flex" data={downloadData}  filename={"report.csv"} ref={csvLinkRef}>
   
      </CSVLink>
          {/* {downloadData.length > 1 ? (
            <ButtonSolid as="span" className="flex flex-center" primary lg onClick={downloadReportList}>
              <IconDownload className="mr8" />CSV
            </ButtonSolid>
          ) : (
            <ButtonSolid as="span" className="flex flex-center"  lg>
              <IconDownload className="mr8" />CSV
            </ButtonSolid>
          )} */}
          </div>
        </>
      </div>
      <div className="mt32">
        <TabsDetailsWrapper>
        <FilterWrapper>  <FilterBox 
          filterForm={filterForm} 
          onFilterChange={onFilterChange} 
          onFilterSubmit={onFilterSubmit}
          refreshPage={refreshPage}
          /></FilterWrapper>
        
        
                     <TableWarpper className="mt50">
                          <table className="table">
                            <thead>
                              <tr>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  User Name
                                    
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  First Name
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                
                                  Last Name
                                  </Text>
                                </th>
                             
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Vpa Id
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Created Date
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Updated Date
                                  </Text>
                                </th>
        
                  
                              
                             </tr>
                            </thead>
                            <tbody>
                              {reportList?.length ? (
                                reportList?.map((list, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.userName}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.firstName}
                                      </Text>
                                    </td>
                  
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.lastName}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.vpaId}
                                      </Text>
                                    </td>
                                  
                                    <td>
                                      <Text size="xsm" color="color3">
                                      {list?.createdAt}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.updatedAt}
                                      </Text>
                                    </td>
                                 
                                </tr>
                                ))
                              ) : !loading ? (
                                <tr>
                                  <td colSpan={12} style={{ textAlign: "center" }}>No record found</td>
                                </tr>
                              ) : (
                                ""
                              )}
                            </tbody>
                          </table>
                        </TableWarpper>

          <div className="mt24 flex flex-center">
            {totalPages > 1 && (
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                getCurrentPageData={(curpage) => {
                  setActivePage(curpage);
                }}
              />
            )}
          </div>
        </TabsDetailsWrapper>
      </div>
    </Wrapper>
  );
}
